import { render, staticRenderFns } from "./Bash.vue?vue&type=template&id=e143148a&scoped=true&"
import script from "./Bash.vue?vue&type=script&lang=js&"
export * from "./Bash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e143148a",
  null
  
)

export default component.exports